export const CAPTURE_UPLOAD_WORKER_SCRIPT_URL = '/capture-upload.worker.js'
export const PREFIX_LOG = `[mockup-generator][capture-upload]`
